<template>
  <div class="form-group" :class="{ 'has-error' : model.$error }" >
    <label v-if="labelPosition === 'left'" class="control-label col-sm-4">
      <slot>{{ required ? '*' : ''}} {{ fieldName }}</slot>
    </label>
    <div :class="labelPosition === 'left' ? 'col-sm-8' : ''">
      <label v-if="labelPosition === 'top'" class="control-label">
        <slot>{{ required ? '*' : ''}} {{ fieldName }}</slot>
      </label>
      <input
        :type="type"
        :name="fieldName"
        class="form-control"
        :placeholder="placeholder"
        v-model="model.$model">

      <div v-if="showDescription" class="description-block">
        <i>{{ descriptionText }}</i>
      </div>

      <div class="help-block pull-right">
        <span v-if="model.$error && model.required === false">{{ fieldName }} is required</span>
        <span v-if="model.$error && model.email === false">{{ fieldName }} is not a valid email</span>
        <span v-if="model.$error && model.sameAsPassword === false">{{ fieldName }} must be the same as password</span>
        <span v-if="model.$error && model.uniqueEmail === false">The email is already in use</span>
        <span v-if="model.$pending && model.uniqueEmail === false">Checking that the email is not in use...</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    model: {
      required: true
    },
    fieldName: {
      required: true
    },
    type: {
      default: 'text',
      required: false
    },
    showRequired: {
      default: true,
      required: false
    },
    placeholder: {
      default: ''
    },
    labelPosition: {
      default: 'left'
    },
    showDescription: {
      default: false
    },
    descriptionText: {
      default: ''
    }
  },

  computed: {
    required () {
      return this.model.$params && !!this.model.$params.required && this.showRequired
    }
  }
}
</script>
